// Caixa do rodízio no comunicado "Dia finalizado" (sininho da gestão): o que ficou
// aberto da pessoa, o que o colega fez por ela e se o dia foi fechado sozinho às 7h.
// Os dados vêm de dados_extras.rodizio (backend routes/rodizio.py, _resumo).

const RodizioResumo = ({ r }) => {
  if (!r) return null;
  const abertas = r.abertas || [];
  const porOutro = r.feitas_por_outro || [];
  return (
    <div className={`mt-4 p-4 rounded-lg border ${abertas.length
      ? 'bg-amber-50 dark:bg-amber-950/30 border-amber-200 dark:border-amber-800'
      : 'bg-green-50 dark:bg-green-950/30 border-green-200 dark:border-green-800'}`}>
      <p className="font-semibold text-sm mb-1">
        Rodízio · {r.pessoa}{r.listas?.length ? ` · lista ${r.listas.map((l) => (l === 'sem_dono' ? 'sem dono' : l)).join(' + ')}` : ''}
      </p>
      {r.automatico && (
        <p className="text-xs font-semibold text-amber-800 dark:text-amber-200 mb-1">
          Fechado pelo ELO às 7h: não clicou em Finalizar dia{r.entrou === false ? ' e não abriu o ELO nesse dia' : ''}.
        </p>
      )}
      {r.ausentes?.length > 0 && (
        <p className="text-xs text-muted-foreground mb-1">Falta marcada: {r.ausentes.join(', ')}.</p>
      )}
      {abertas.length ? (
        <ul className="list-disc list-inside text-sm space-y-0.5">
          {abertas.map((a) => <li key={a.tipo + a.nome}>{a.nome} <span className="text-muted-foreground">({a.tipo})</span></li>)}
        </ul>
      ) : (
        <p className="text-sm">Nada ficou aberto.</p>
      )}
      {porOutro.length > 0 && (
        <p className="text-xs text-muted-foreground mt-2">
          Feito por outra pessoa: {porOutro.map((f) => `${f.nome} (${f.por})`).join(', ')}.
        </p>
      )}
    </div>
  );
};

export default RodizioResumo;
